import { useShowSuccess, useShowError } from 'hooks/useToast'
import { useAddPolicyToGroupMutation } from '../../../../../graphql'

export default function useAddPolicyHandler() {
	const [ addPolicyToGroup ] = useAddPolicyToGroupMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( group: { id: number }, roleId: number, resourceId: number ) => {
		const groupId = group.id

		const result = await addPolicyToGroup( { variables: { groupId, roleId, resourceId } } )
		if ( result.data?.addPolicyToGroup?.success ) {
			showSuccess( `addPolicyToGroupSuccess${Date.now()}`, result.data?.addPolicyToGroup?.message ?? 'Successfully added policy to group!' )
		} else {
			showError( `addPolicyToGroupError${Date.now()}`, result.data?.addPolicyToGroup?.message ?? 'Sorry, an error occurred' )
		}
	}
}
